S.accordion = {
    config: {
        // group: gruppe für accordion
        mode: null,
        group: null,
    },

    elements: {},

    init()
    {
        this.initAccordion();
    },

    initAccordion()
    {
        if (this.config.mode === 'accordion')
        {
            // this.$module.find('.mod-toggle:not(.mod-accordion .mod-toggle)').addClass('is-accordion');

            // this.$module.find('.m-wrapper > .m-content > .mod-toggle').each(function() {
            //   $( this ).attr('data-group', uniqid);
            // });

            // set data-group in mod-toggle
            const uniqid = Math.random().toString(36).substr(2, 9);

            this.$module.find('> .m-wrapper-container > .m-content > .mod-toggle').attr('data-group', uniqid);
        }
    },
};
